/* Wojo Succeed theme JS */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Money formatting from the shop's own format string */
  function addCommas(num) {
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function formatMoney(cents) {
    var format = document.body.getAttribute('data-money-format') || '${{amount}}';
    var amount = addCommas((cents / 100).toFixed(2));
    var noDecimals = addCommas(Math.round(cents / 100).toString());
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount);
  }
  window.WojoMoney = formatMoney;

  /* ---------- Sticky offsets (announcement + header heights) ---------- */
  /* Uses the announcement bar's VISIBLE height (it scrolls away), so the
     header/nav stick flush to the top mid-page and drawers never gap. */
  function setStickyOffsets() {
    var bar = document.querySelector('.announcement-bar');
    var header = document.querySelector('.site-header');
    var ah = 0;
    if (bar) {
      var rect = bar.getBoundingClientRect();
      ah = Math.max(0, Math.min(rect.bottom, rect.height));
    }
    var hh = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-height', ah + 'px');
    document.documentElement.style.setProperty('--sticky-offset', (ah + hh) + 'px');
  }
  setStickyOffsets();
  window.addEventListener('resize', setStickyOffsets);
  window.addEventListener('load', setStickyOffsets);
  window.addEventListener('scroll', setStickyOffsets, { passive: true });

  /* ---------- Cart drawer ---------- */
  /* Always query fresh: the theme editor re-renders sections, which would
     leave a cached node detached from the DOM (drawer stops opening). */
  function getDrawer() {
    return document.getElementById('CartDrawer');
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.add('is-open');
    document.body.classList.add('drawer-open');
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }

  function refreshDrawer(openAfter) {
    fetch(ROOT + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        var current = getDrawer();
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
        }
        updateCartCount();
      })
      .catch(function () { /* editor/preview fetch can fail — still open */ })
      .finally(function () {
        if (openAfter) openDrawer();
      });
  }

  function updateCartCount() {
    fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      refreshDrawer(true);
    }
    if (e.target.closest('[data-cart-close]') || e.target.classList.contains('cart-drawer__overlay')) {
      closeDrawer();
    }
    var removeLink = e.target.closest('[data-cart-remove]');
    if (removeLink) {
      e.preventDefault();
      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: removeLink.getAttribute('data-cart-remove'), quantity: 0 })
      }).then(function () { refreshDrawer(true); });
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    document.body.classList.remove('menu-open', 'shop-drawer-open');
    document.querySelectorAll('.pdp-modal.is-open, .pdp-lightbox.is-open').forEach(function (m) {
      m.classList.remove('is-open');
    });
  });

  /* AJAX add-to-cart for product forms marked data-ajax-cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'ADDING…'; }
    fetch(ROOT + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function () { refreshDrawer(true); })
      .catch(function (err) {
        alert((err && err.description) || 'Could not add to cart');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = orig; }
      });
  });

  /* ---------- Product-card quick add ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-quick-toggle]');
    if (toggle) {
      var card = toggle.closest('[data-product-card]');
      document.querySelectorAll('[data-product-card].is-quick-open').forEach(function (c) {
        if (c !== card) c.classList.remove('is-quick-open');
      });
      card.classList.toggle('is-quick-open');
      return;
    }
    var quickAdd = e.target.closest('[data-quick-add-variant]');
    if (quickAdd) {
      e.preventDefault();
      var orig = quickAdd.textContent;
      quickAdd.disabled = true;
      quickAdd.textContent = '…';
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: quickAdd.getAttribute('data-quick-add-variant'), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw j; });
          return r.json();
        })
        .then(function () {
          var openCard = quickAdd.closest('[data-product-card]');
          if (openCard) openCard.classList.remove('is-quick-open');
          refreshDrawer(true);
        })
        .catch(function (err) { alert((err && err.description) || 'Could not add to cart'); })
        .finally(function () { quickAdd.disabled = false; quickAdd.textContent = orig; });
      return;
    }
    if (!e.target.closest('[data-product-card]')) {
      document.querySelectorAll('[data-product-card].is-quick-open').forEach(function (c) {
        c.classList.remove('is-quick-open');
      });
    }
  });

  /* ---------- Quantity boxes ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var box = btn.closest('.qty-box');
    var input = box && box.querySelector('[data-qty-input]');
    if (!input) return;
    var next = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty-change'), 10);
    input.value = Math.max(parseInt(input.min || '0', 10), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Auto-submit cart page qty changes */
  document.addEventListener('change', function (e) {
    if (e.target.matches('.cart-page [data-qty-input]')) {
      var f = e.target.closest('form');
      if (f) f.submit();
    }
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var json = wrapper.querySelector('[data-variants-json]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = wrapper.querySelector('[name="id"]');
    var atcBtn = wrapper.querySelector('[data-atc-button]');
    var priceEl = wrapper.querySelector('[data-price-area]');

    function currentOptions() {
      var opts = [];
      wrapper.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked') || group.querySelector('select');
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function onChange() {
      var v = findVariant(currentOptions());
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'UNAVAILABLE'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? (atcBtn.getAttribute('data-atc-text') || 'ADD TO CART') : 'SOLD OUT';
      }
      if (priceEl) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          html = '<s class="price--compare">' + formatMoney(v.compare_at_price) + '</s> ' +
                 '<span class="price--sale">' + formatMoney(v.price) + '</span> ' +
                 '<span class="price__badge-sale">' + pct + '% OFF</span>';
        } else {
          html = '<span class="price--regular">' + formatMoney(v.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      var stickyPrice = document.querySelector('.sticky-atc__price');
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    wrapper.querySelectorAll('[data-option-index] input, [data-option-index] select').forEach(function (el) {
      el.addEventListener('change', onChange);
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var full = thumb.getAttribute('data-full');
        if (main && full) {
          var img = main.querySelector('img');
          if (img) { img.src = full; img.srcset = ''; }
        }
      });
    });
  });

  /* ---------- Sticky add-to-cart bar ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainAtc = document.querySelector('[data-atc-button]');
  if (stickyBar && mainAtc) {
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px' });
    observer.observe(mainAtc);
    var stickyBtn = stickyBar.querySelector('[data-sticky-atc-button]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        mainAtc.closest('form') && mainAtc.click();
      });
    }
  }

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      document.body.classList.add('menu-open');
    }
    if (e.target.closest('[data-menu-close]') || e.target.classList.contains('mobile-menu__overlay')) {
      document.body.classList.remove('menu-open');
    }
  });

  /* ---------- Announcement / marquee duplication for seamless loop ---------- */
  document.querySelectorAll('[data-marquee]').forEach(function (m) {
    var inner = m.querySelector('.marquee__inner');
    if (!inner) return;
    var copy = inner.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    m.appendChild(copy);
  });

  updateCartCount();
})();
